<template>

<app-inner>

	<app-text v-html="page.content" />

</app-inner>

</template>

<script>

import mixinPage from '@/mixin/page.js'

export default {

    mixins: [mixinPage]

}

</script>

<style scoped>

</style>
